<template>
        <vue-autocomplete
        class="w-100"
        :data="items"
        placeholder="Procurar Pessoa Física"
        v-model="query"
        :serializer="item => item.pessoa"
        @hit="selecionarPessoa($event)"
        @input="buscarPessoasFisicas"
        showOnFocus
        :disabled="disabled"
        :maxMatches=parseInt(5)
        >
      <template slot="suggestion" slot-scope="{ htmlText }">
        <div class="d-flex">
	        <b-spinner v-show="carregando" variant="primary" class="mx-auto"></b-spinner>
            <span class="ml-4" v-html="htmlText" v-show="!carregando"></span>
        </div>
      </template>
    </vue-autocomplete>
  </template>
<script>
import PessoaService from "../../service/PessoaService.js";

export default {
	props: [ "disabled" ],
	data() {
		return {
			query: "",
			items: [],
			carregando: false,
		};
	},
	methods: {
		buscarPessoasFisicas() {
			this.carregando = true;
			PessoaService.filtrarPessoasFisicas(this.query)
				.then((res) => {
					const arr = [];
					res.data.forEach((p) => {
						const pessoa = {
							pessoa: p[0],
							cpf: p[1],
						};
						arr.push(pessoa);
					});
    			    this.items = arr;
				}).finally(() => {
					this.carregando = false;
				});
		},
		selecionarPessoa(item) {
			this.$emit("pessoaSelecionada", item.cpf);
		},
		limpar() {
			this.query = "";
			this.items = [];
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/pessoa/AutoCompletePessoaFisica.vue